import React from 'react';
import { Table } from 'antd';
import { useSelector } from 'react-redux';
import { SearchIcon } from '../Users/components/Table/icons/SearchIcon';
import { useOrgTable } from './organizations.utils';
import { AddOrganization } from './components/AddOrganization/AddOrganization';
import { useToggle } from '../../components';
import { RootState } from '../../store/store';
import { DeleteOrgModal } from './components/DeleteOrgModal/DeleteOrgModal';
import { AddIcon } from '../../components/Icons/AddIcon';

export const Organizations: React.FC = (): JSX.Element => {
  const {
    rowSelection,
    cols,
    orgs,
    handleDelete,
    editOpen,
    handleEdit,
  } = useOrgTable();
  const { open, toggle } = useToggle(false);
  const { deleteModalOpen, currentOrg } = useSelector(
    (state: RootState) => state.orgs
  );
  return (
    <div>
      <div className="table__controls">
        <div className="table__controls-left">
          <AddIcon tooltipText="Add new organization" onClick={toggle} />
        </div>
        <SearchIcon />
      </div>
      <Table
        rowSelection={{ type: 'checkbox', ...rowSelection }}
        columns={cols}
        dataSource={orgs}
        rowClassName={(record) => (record.invitationSent ? 'disabled' : '')}
      />
      <AddOrganization isAdd open={open} onClose={toggle} />
      <AddOrganization org={currentOrg} open={editOpen} onClose={handleEdit} />
      <DeleteOrgModal open={deleteModalOpen} onClose={handleDelete} />
    </div>
  );
};
